import { graphql } from 'react-relay';

export const selectboxFragment = graphql`
    fragment Selectbox_selectBox on SelectBox {
        options {
            key
            label
            data
        }
    }
`;
